import React from 'react'
import { Field } from 'redux-form'
import renderSelect from '../fields/renderSelect'
import i18n from '../../translations/i18n';

let DeliveryOptions = props => {
	let lng = props.lng;
	return (
		<div>
		<div className="form-section">
		<div className="subtitle title title-border title-border text-left">
			<h6>{i18n.t('delivery.title', {lng})}</h6>
		</div>
		<p className="small tooltip-text">{i18n.t('delivery.subtitle1', {lng})}<br></br>{i18n.t('delivery.subtitle2', {lng})}</p>
		<div className="row">
			<div className="col-6 form-input check-with-tooltip">
			<label className='simple-checkbox'>
				{i18n.t('delivery.email', {lng})}
				<Field
					name="emailDelivery"
					component="input"
					type="checkbox"
					label={i18n.t('delivery.email', {lng})}
					checked="checked"
					value="emailDelivery"
				/>
				<span className="checkboxmark"></span>
				</label>
			</div>
			<div className="col-6 form-input check-with-tooltip">
				<label className='simple-checkbox'>
				{i18n.t('delivery.tracked_letter', {lng})}
				<Field
					name="trackedLetterDelivery"
					component="input"
					type="checkbox"
					label={i18n.t('delivery.tracked_letter', {lng})}
					value="trackedLetterDelivery"
					onChange={props.checkboxChange}
				/>
				<span className="checkboxmark"></span>
				</label>
			</div>
		</div>
		<div className="row">
			{props.shippingCountry==="France"&&<div className="col-6 form-input check-with-tooltip">
			<label className='simple-checkbox'>
				{i18n.t('delivery.registered_letter', {lng})}
				<Field
					name="registeredLetterDelivery"
					component="input"
					type="checkbox"
					label={i18n.t('delivery.registered_letter', {lng})}
					value="registeredLetterDelivery"
					onChange={props.checkboxChange}
				/>
				<span className="checkboxmark"></span>
				</label>
			</div>}
			<div className="col-6 form-input check-with-tooltip">
				<label className='simple-checkbox'>
				{i18n.t('delivery.office', {lng})}
				<Field
					name="officeCollectionDelivery"
					component="input"
					type="checkbox"
					label={i18n.t('delivery.office', {lng})}
					value="officeCollectionDelivery"
					onChange={props.checkboxChange}
				/>
				<span className="checkboxmark"></span>
				</label>
			</div>
			{(props.shippingCountry==="France"||props.shippingCountry==="United Kingdom")&&<div className="col-6 form-input check-with-tooltip">
				<label className='simple-checkbox'>
					{i18n.t('delivery.courier', {lng})}
					<Field
						name="courierServiceDelivery"
						component="input"
						type="checkbox"
						label={i18n.t('delivery.courier', {lng})}
						value="courierServiceDelivery"
						onChange={props.checkboxChange}
					/>
					<span className="checkboxmark"></span>
				</label>
			</div>}
		</div>
		{(props.selectedService&&(props.shippingCountry==="France"||props.shippingCountry==="United Kingdom"))&&<div className="col-12 form-input mb-3">
			<Field
				name="courierOption"
				component={renderSelect}
				label={i18n.t('delivery.courier_options', {lng})}
				options={props.courierServices}
				placeholder={i18n.t('app.please_select', {lng})}
			/>
		</div>}
	</div>
	</div>
	)
  }


  export default DeliveryOptions


// WEBPACK FOOTER //
// ./src/components/common/deliveryOptions.js